const hero = [
    {
        image: 'cheetah',
        title: 'Cheetah!?',
        description: "Cheetahs have a long, slender body measuring 1.2 metres (4 feet), with a long tail (65–85 cm [2–3 feet]) that generally ends in a white tuft. They are about 75 cm tall at the shoulder. Weight ranges from 34 to 54 kg (75 to 119 pounds), males being slightly larger than females.",
    },
    {
        image: 'eating_cheetah',
        title: 'Diet',
        description: "These carnivores eat small antelope, including springbok, steenbok, duikers, impala and gazelles, as well as the young of larger animals, such as warthogs, kudu, hartebeest, oryx, roan and sable. Cheetahs also hunt game birds and rabbits."
    },
    {
        image: 'habitat_cheetah',
        title: 'Habitat',
        description: "Although they typically prefer open grasslands, cheetahs live in a range of habitats across eastern and southern Africa. Once found throughout Asia and Africa, cheetahs today are racing toward extinction."
    },
    {
        image: 'behavior_cheetah',
        title: 'Behavior',
        description: "Cheetahs are very timid and avoid lions and hyenas at all costs. Their fresh kill is often taken by an intruding hyena or lion because the cheetah is too timid and tired to put up a fight. Many times cheetahs are even threatened by their prey."
    },
    {
        image: 'lifecycle_cheetah',
        title: 'Lifecycle',
        description: "One of the most incredible things about the cheetahs is the remarkable processes and transitions in their lifecycle. From born at an average weight of 350 grams and completely helpless and unable to see, to becoming one of the most skilled predators and the fastest land animal on the planet, nothing speaks more about the incredible adaptations that allow them to survive and thrive in the challenging environments where they live."
    },
    {
        image: 'facts_cheetah',
        title: 'Facts!',
        description: "Cheetahs are overall a very interesting and unique creation of mother nature."
    }
];

export { hero };